import { useState } from "react";
import { useAppContext } from "../../Libs/contextLib";
import { isUserAdmin } from "../../Libs/helperLib";
import { useMediaQuery } from "../../Libs/hookLibs";
import styles from "./Header.module.css";

import { Logo } from "./Logo";
import { AccountPopover } from "../AccountPopover";
import { NavMenuBtn } from "./NavMenuBtn";
import { NavHeader } from "./NavHeader";
import { NavDrawer } from "./NavDrawer";

const navLinks = [
  {
    text: "Video Channel",
    link: "/VideoChannel",
  },
  {
    text: "Recognition",
    link: "/Recognition",
  },
];

const adminLinks = [
  {
    text: "Video Manager",
    link: "/VideoManager",
  },
  {
    text: "Reporting",
    link: "/Reporting",
  },
];

const getNavLinks = (userIsAdmin) => {
  return navLinks.concat(userIsAdmin ? adminLinks : []);
};

export const Header = () => {
  const [isNavDrawerOpen, setNavDrawer] = useState(false);
  const { currUser } = useAppContext();
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const toggleNavDrawer = (event) => {
    event.preventDefault();
    setNavDrawer(!isNavDrawerOpen);
  };

  return (
    <div
      style={{
        background: "black",
        margin: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Logo />
        <AccountPopover />
      </div>
    </div>
  );
};
